(() => {
  const init = async (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const profile = JSON.parse(root.querySelector('[data-wc-profile]').textContent);
    const labels = JSON.parse(root.querySelector('[data-wc-labels]').textContent);
    const $ = selector => root.querySelector(selector);
    const rail = $('[data-wc-best]');
    const configs = $('[data-wc-configs]');
    const routeRoot = window.Shopify?.routes?.root || '/';
    let products = [];
    const scopedTypes = profile.native ? profile.types : [];
    const scope = url => {
      if (scopedTypes.length) {
        const selected = url.searchParams.getAll('pf_pt_product_type');
        if (!selected.length || selected.some(type => !scopedTypes.includes(type))) {
          url.searchParams.delete('pf_pt_product_type');
          scopedTypes.forEach(type => url.searchParams.append('pf_pt_product_type', type));
        }
        if (new URL(location.href).searchParams.has('view') || profile.collection === 'appliances') url.searchParams.set('view', 'ap-' + profile.key);
      }
      return url;
    };
    const ensureScope = () => {
      const current = new URL(location.href);
      const next = scope(new URL(current));
      if (next.href !== current.href) { location.replace(next.href); return false; }
      return true;
    };
    if (!ensureScope()) return;
    root.querySelectorAll('[data-wc-name]').forEach(el => { el.textContent = profile.title; });
    $('[data-wc-grid-title]').textContent = labels.allHeading.replace('__CATEGORY__', profile.title.toLowerCase());
    const text = (tag, cls, value) => {
      const el = document.createElement(tag);
      if (cls) el.className = cls;
      el.textContent = value;
      return el;
    };
    const card = (p, eager = false) => {
      const link = document.createElement('a');
      link.className = 'wc-card';
      link.href = p.url;
      const media = document.createElement('div');
      media.className = 'wc-card-image';
      if (p.image) {
        const img = document.createElement('img');
        img.src = p.image;
        img.width = 560;
        img.height = 560;
        img.alt = '';
        img.loading = eager ? 'eager' : 'lazy';
        media.append(img);
      }
      const copy = document.createElement('div');
      copy.className = 'wc-card-copy';
      copy.append(text('p', 'wc-vendor', p.vendor), text('h3', '', p.title));
      const price = p.price > 0 ? (p.varies ? labels.from + ' ' : '') + p.money : labels.askPrice;
      copy.append(text('p', 'wc-price', price));
      if (!p.available) copy.append(text('p', 'wc-soldout', labels.soldOut));
      const detail = text('span', 'wc-detail', labels.details);
      const arrow = text('span', '', '→');
      arrow.setAttribute('aria-hidden', 'true');
      detail.append(arrow);
      copy.append(detail);
      link.append(media, copy);
      return link;
    };

    const shortcuts = () => {
      const groups = new Map();
      products.forEach(product => product.tags.forEach(tag => {
        const split = tag.indexOf('_');
        if (split < 1) return;
        const prefix = tag.slice(0, split);
        const key = 'pf_t_' + prefix.toLowerCase().replace(/[^a-z0-9]+/g, '_');
        if (!document.getElementById(key + '-toggle')) return;
        if (/vendor|finish|stock/.test(key)) return;
        if (!groups.has(key)) groups.set(key, new Set());
        groups.get(key).add(tag);
      }));
      return profile.configs.flatMap(config => {
        const matcher = new RegExp(config.match, 'i');
        const exclude = config.exclude ? new RegExp(config.exclude, 'i') : null;
        for (const [key, values] of groups) {
          const tags = [...values].filter(tag => {
            const value = tag.slice(tag.indexOf('_') + 1).replace(/[–—-]/g, ' ');
            return matcher.test(value) && (!exclude || !exclude.test(value));
          });
          if (tags.length && config.match !== '.*') return [{...config, filterKey:key, values:tags}];
        }
        return [];
      });
    };
    let signature = '';
    const sync = () => {
      if (!ensureScope()) return;
      const options = shortcuts();
      const current = new URL(location.href);
      const signatureNow = JSON.stringify(options.map(option => [option.key,option.filterKey,option.values]));
      if (signatureNow !== signature) {
        signature = signatureNow;
        configs.replaceChildren();
        const all = text('a','',labels.all);
        all.dataset.all = 'true';
        configs.append(all);
        options.forEach(option => {
          const link = text('a','',option.label);
          link.dataset.config = option.key;
          configs.append(link);
        });
      }
      $('.wc-configs').hidden = !options.length;
      configs.querySelectorAll('a').forEach(link => {
        const next = new URL(current);
        let selected = false;
        if (link.dataset.all) {
          [...next.searchParams.keys()].filter(key => key.startsWith('pf_') || key.startsWith('ap_')).forEach(key => next.searchParams.delete(key));
          selected = ![...current.searchParams.keys()].some(key => key.startsWith('pf_') && !(scopedTypes.length && key === 'pf_pt_product_type'));
        } else {
          const option = options.find(item => item.key === link.dataset.config);
          const values = current.searchParams.getAll(option.filterKey);
          selected = option.values.every(value => values.includes(value));
          next.searchParams.delete(option.filterKey);
          if (!selected) option.values.forEach(value => next.searchParams.append(option.filterKey, value));
        }
        next.searchParams.delete('page');
        next.searchParams.delete('pf_page');
        next.searchParams.delete('preview_theme_id');
        next.hash = 'category-products';
        scope(next);
        const href = next.pathname + next.search + next.hash;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        link.classList.toggle('is-active',selected);
        if (selected) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      root.querySelectorAll('[data-wc-all]').forEach(link => {
        const next = new URL(current);
        [...next.searchParams.keys()].filter(key => key.startsWith('pf_') || key.startsWith('ap_')).forEach(key => next.searchParams.delete(key));
        next.searchParams.delete('page');
        next.hash = 'category-products';
        scope(next);
        const href = next.pathname + next.search + next.hash;
        if (link.getAttribute('href') !== href) link.setAttribute('href',href);
      });
    };
    const updateArrows = () => {
      $('[data-wc-prev]').disabled = rail.scrollLeft < 2;
      $('[data-wc-next]').disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      $('.wc-arrows').hidden = rail.scrollWidth <= rail.clientWidth + 2;
    };
    $('[data-wc-prev]').addEventListener('click', () => rail.scrollBy({left:-rail.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
    $('[data-wc-next]').addEventListener('click', () => rail.scrollBy({left:rail.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
    rail.addEventListener('scroll',updateArrows,{passive:true});
    new ResizeObserver(updateArrows).observe(rail);
    new MutationObserver(sync).observe(document.body,{childList:true,subtree:true});
    window.addEventListener('popstate',sync);
    document.addEventListener('click',event => { if (event.target.closest('[data-wc-configs] a, [data-wc-all]')) sync(); },true);
    document.addEventListener('pointerover',event => { if (event.target.closest('[data-wc-configs] a, [data-wc-all]')) sync(); },true);
    document.addEventListener('focusin',event => { if (event.target.closest('[data-wc-configs] a, [data-wc-all]')) sync(); },true);
    sync();
    const load = async () => {
      $('[data-wc-error]').hidden = true;
      rail.setAttribute('aria-busy','true');
      try {
        let page = 1;
        const found = [];
        while (page) {
          const url = new URL(routeRoot + 'collections/' + profile.collection,location.origin);
          url.searchParams.set('view','appliance-data');
          url.searchParams.set('sort_by','best-selling');
          url.searchParams.set('page',page);
          const response = await fetch(url,{signal:AbortSignal.timeout(20000)});
          if (!response.ok) throw new Error('Catalog request failed');
          const data = await response.json();
          if (data.sort !== 'best-selling' || !Array.isArray(data.products)) throw new Error('Invalid catalog response');
          found.push(...data.products);
          page = data.next;
          if (page > 20) throw new Error('Catalog pagination limit');
        }
        products = found.filter(product => !profile.types.length || profile.types.includes(product.type));
        products.forEach(product => { product.money = new DOMParser().parseFromString(product.money,'text/html').body.textContent; });
        const eligible = products.filter(product => product.image && !/\b(kit|liner|extension|handle kit|assembly|assembley)\b/i.test(product.title));
        const best = (eligible.length ? eligible : products.filter(product => product.image)).slice(0,4);
        rail.replaceChildren(...best.map(product => card(product,true)));
        $('[data-wc-featured]').hidden = !best.length;
        const current = new URL(location.href);
        const legacy = current.searchParams.get('ap_config');
        const option = shortcuts().find(item => item.key === legacy);
        if (option) { current.searchParams.delete(option.filterKey); option.values.forEach(value => current.searchParams.append(option.filterKey,value)); }
        if (current.searchParams.has('ap_brand')) current.searchParams.set('pf_v_vendor',current.searchParams.get('ap_brand'));
        if (current.searchParams.has('ap_max')) current.searchParams.set('pf_p_price','0:' + current.searchParams.get('ap_max'));
        if (current.searchParams.has('ap_sort')) current.searchParams.set('sort',current.searchParams.get('ap_sort'));
        const legacyKeys = ['ap_config','ap_brand','ap_max','ap_sort'];
        if (legacyKeys.some(key => current.searchParams.has(key))) {
          legacyKeys.forEach(key => current.searchParams.delete(key));
          location.replace(scope(current).href);
          return;
        }
        sync();
        updateArrows();
      } catch (error) {
        $('[data-wc-error]').hidden = false;
        $('[data-wc-featured]').hidden = true;
      } finally { rail.setAttribute('aria-busy','false'); }
    };
    $('[data-wc-retry]').addEventListener('click',load);
    await load();
  };
  const initialize = () => document.querySelectorAll('[data-appliance-category]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
